import { pdfjs } from 'react-pdf';

// Configure PDF.js worker only when react-pdf is actually used
export const configurePDFWorker = () => {
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
  }
};
